import { render } from "./lAccountName.vue?vue&type=template&id=5561beb2&ts=true"
import script from "./lAccountName.vue?vue&type=script&lang=ts"
export * from "./lAccountName.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__